import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbCalendar, NgbDate, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { map, startWith } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { environment } from 'src/environments/environment';
import { DealIdExplainationPopupComponent } from '../deal-id-explaination-popup/deal-id-explaination-popup.component';
import { TrialFormValue } from '../../models/trial-link.model';
import { EMAIL_REGEX } from 'src/app/shared/email-regex.const';

@Component({
  selector: 'gdp-trial-link-form',
  templateUrl: './trial-link-form.component.html',
  styleUrls: ['./trial-link-form.component.scss']
})
export class TrialLinkFormComponent implements OnInit {
  public form: UntypedFormGroup;
  public countries = environment.servedCountries;
  public startDay: NgbDate;
  public language$: Observable<string> = this.translateService.onLangChange.pipe(
    map((e: LangChangeEvent) => e.lang),
    startWith(this.translateService.currentLang)
  );


  @Output() emitFormValues: EventEmitter<TrialFormValue> = new EventEmitter();

  constructor(
    private fb: UntypedFormBuilder,
    private modalService: NgbModal,
    private translateService: TranslateService,
    private ngbCalendar: NgbCalendar
  ) { }

  ngOnInit(): void {
    this.startDay = this.ngbCalendar.getNext(this.ngbCalendar.getToday());
    this.form = this.fb.group({
      name: new FormControl<string>('', [Validators.required]),
      email: new FormControl<string>('', [Validators.required, Validators.pattern(EMAIL_REGEX)]),
      country: new FormControl<{ iso2: string }>(null),
      deal_id: new FormControl<string>('', [Validators.required]),
      sms: new FormControl<boolean>(true, [Validators.required]),
      date: new FormControl<NgbDate>(this.startDay, [Validators.required])
    });
  }

  public isControlInvalid(name: string): boolean {
    return this.getFormControl(name).invalid && this.getFormControl(name).dirty;
  }

  public getFormControl(name: string) {
    return this.form.controls[name];
  }

  public openDealIdModal(): void {
    this.modalService.open(DealIdExplainationPopupComponent, { size: 'lg' });
  }

  public onSubmit(): void {
    if (this.form.valid) {
      this.emitFormValues.emit(this.form.value);
      this.form.reset();
      this.getFormControl('country').setValue(this.countries[0]);
      this.getFormControl('sms').setValue(true);
      this.getFormControl('date').setValue(this.startDay);
    }
  }
}
